import Quiz from './components/Quiz';
import './App.css';

function App() {
  return (
    <div className="App">
      <Quiz />
    </div>
  );
}

export default App;
